import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// import { ReactSortable } from "react-sortablejs";
// import { debounce } from "lodash";
import {
  RatingApplicationsList as StyledRatingApplicationsList,
  RatingApplicationsListContainer,
  RatingApplicationsListContent,
  RatingApplicationsListHeader,
  RatingApplicationsSubgroup,
} from "./ratingApplicationsList.styles";
import { TitleH1, TitleH2 } from "../../../../../shared/native/typography.styles";
import {
  getApplicationsRequest,
  // saveApplicationsPriorityRequest,
} from "../../../../../../http/requests/applications/applications.http";
import { useAppDispatch } from "../../../../../../core/hooks/redux";
import { resetHighEducationState } from "../../../../../../store/modules/applications/highEducation/highEducationSlice";
import Loader from "../../../../../shared/loaders/Loader";
import { resetAdditionalEducationState } from "../../../../../../store/modules/applications/additionalEducation/additionalEducationSlice";
import capitalize from "../../../../../../core/utils/capitalize";
import graduateInfo from "../../selectApplicationType/constants/graduateInfo";
import { resetPostgraduateEducationState } from "../../../../../../store/modules/applications/postgraduateEducation/postgraduateEducationSlice";
import degreeType from "../../../../../../core/types/degreeType";
import ApplicationsLists from "../../../../../../core/interfaces/applications/ApplicationsLists";
import PaymentType from "./types/paymentType";
import loading from "../../../../../../core/types/loading";
import { DashedButton } from "../../../../../shared/native/button.styles";
import SelectPaymentGroup from "./components/selectPaymentGroup/SelectPaymentGroup";
import PaymentInfo from "./constants/paymentInfo";
// import ApplicationInfo from "../../../../../../core/interfaces/applications/ApplicationInfo";
import ApplicationCard from "./components/applicationsCards";
import colors from "../../../../../../core/styles/colors";

const RatingApplicationsList: React.FC<{ degree: degreeType }> = ({ degree }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loadingStatus, setLoadingStatus] = useState<loading>(null);
  const [paymentGroups, setPaymentGroups] = useState<Record<PaymentType, PaymentInfo> | null>(null);
  const [selectedPaymentType, setSelectedPaymentType] = useState<PaymentType | null>(null);

  const currentPaymentGroup: PaymentInfo | null =
    paymentGroups && selectedPaymentType ? paymentGroups[selectedPaymentType] : null;

  React.useEffect(() => {
    setLoadingStatus("LOADING");

    getApplicationsRequest(degree).then((res) => {
      if (res.data.error) {
        setLoadingStatus("ERROR");
        return;
      }
      setLoadingStatus("COMPLETE");

      const resApplications = res.data.payload as ApplicationsLists;

      if (![...resApplications.budget, ...resApplications.paid, ...resApplications.draft]?.length) {
        navigate(`/applications/${degree}-education/submission-info`);
        return;
      }

      setPaymentGroups({
        paid: new PaymentInfo("paid", resApplications.paid),
        budget: new PaymentInfo("budget", resApplications.budget),
        draft: new PaymentInfo("draft", resApplications.draft),
      });
    });
  }, []);

  const createNewApplication = (): void => {
    document.cookie = `lastModified${capitalize(degree)}EducationApplicationId=null; path=/`;
    document.cookie = `lastModified${capitalize(degree)}EducationStep=0; path=/`;
    dispatch(resetHighEducationState());
    dispatch(resetAdditionalEducationState());
    dispatch(resetPostgraduateEducationState());
    navigate(`/applications/${degree}-education/submission-info`);
  };

  // const saveApplicationsListPriority = useCallback(
  //   debounce(() => {
  //     saveApplicationsPriorityRequest({
  //       paid: paymentGroups.paid.applications,
  //       budget: paymentGroups.budget.applications,
  //       draft: paymentGroups.draft.applications,
  //     });
  //   }, 1000),
  //   [currentPaymentGroup]
  // );

  // const changeApplicationsPriority = (
  //   subgroupName: "bachelor_specialist" | "master",
  //   newList: ApplicationInfo[]
  // ): void => {
  //   currentPaymentGroup.subgroups[subgroupName].applications = newList.map(
  //     (application, index) => ({
  //       ...application,
  //       priority: index + 1,
  //     })
  //   );
  //
  //   setPaymentGroups({ ...paymentGroups, [selectedPaymentType]: currentPaymentGroup });
  //   saveApplicationsListPriority();
  // };

  if (loadingStatus === "LOADING") {
    return (
      <RatingApplicationsListContainer>
        <Loader type="spinner" />
      </RatingApplicationsListContainer>
    );
  }

  return (
    <RatingApplicationsListContainer>
      <RatingApplicationsListContent>
        <RatingApplicationsListHeader>
          <TitleH1>Заявления на {graduateInfo[degree].text}</TitleH1>
          <DashedButton onClick={createNewApplication}>Новое заявление</DashedButton>
        </RatingApplicationsListHeader>

        <SelectPaymentGroup
          degree={degree}
          paymentGroups={paymentGroups}
          selectedPaymentType={selectedPaymentType}
          setSelectedPaymentType={setSelectedPaymentType}
        />

        {currentPaymentGroup && selectedPaymentType && (
          <div key={selectedPaymentType}>
            {currentPaymentGroup.name === "draft" ? (
              <StyledRatingApplicationsList>
                <div className="sortableList">
                  {currentPaymentGroup.applications.map((application) => (
                    <ApplicationCard
                      key={`${selectedPaymentType}-${application.id}`}
                      application={application}
                      priority={null}
                      degree={degree}
                      paymentType={selectedPaymentType}
                      className={null}
                    />
                  ))}
                </div>
              </StyledRatingApplicationsList>
            ) : (
              Object.entries(currentPaymentGroup.subgroups).map(([subgroupName, subgroup]) => {
                if (!subgroup.applications.length) return null;

                return (
                  <RatingApplicationsSubgroup key={`${selectedPaymentType}-${subgroupName}`}>
                    <TitleH2 style={{ color: colors.black.general }}>{subgroup.name}</TitleH2>

                    <StyledRatingApplicationsList>
                      <div className="sortableList">
                        {subgroup.applications.map((application) => (
                          <ApplicationCard
                            key={`${selectedPaymentType}-${application.id}`}
                            application={application}
                            priority={application.priority}
                            degree={degree}
                            paymentType={selectedPaymentType}
                            className="item sortableItem"
                          />
                        ))}
                      </div>
                    </StyledRatingApplicationsList>
                  </RatingApplicationsSubgroup>
                );
              })
            )}
          </div>
        )}
      </RatingApplicationsListContent>
    </RatingApplicationsListContainer>
  );
};

export default RatingApplicationsList;
